var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpertModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_2201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.125H3.75C3.41848 3.125 3.10054 3.2567 2.86612 3.49112C2.6317 3.72554 2.5 4.04348 2.5 4.375V11.875C2.5 12.2065 2.6317 12.5245 2.86612 12.7589C3.10054 12.9933 3.41848 13.125 3.75 13.125H7.31062",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.75V11.25H13.75",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.875V4.375C11.25 4.04348 11.1183 3.72554 10.8839 3.49112C10.6495 3.2567 10.3315 3.125 10 3.125H8.75",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.125C5 2.79348 5.1317 2.47554 5.36612 2.24112C5.60054 2.0067 5.91848 1.875 6.25 1.875H7.5C7.83152 1.875 8.14946 2.0067 8.38388 2.24112C8.6183 2.47554 8.75 2.79348 8.75 3.125C8.75 3.45652 8.6183 3.77446 8.38388 4.00888C8.14946 4.2433 7.83152 4.375 7.5 4.375H6.25C5.91848 4.375 5.60054 4.2433 5.36612 4.00888C5.1317 3.77446 5 3.45652 5 3.125Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.25C8.75 11.913 9.01339 12.5489 9.48223 13.0178C9.95107 13.4866 10.587 13.75 11.25 13.75C11.913 13.75 12.5489 13.4866 13.0178 13.0178C13.4866 12.5489 13.75 11.913 13.75 11.25C13.75 10.587 13.4866 9.95107 13.0178 9.48223C12.5489 9.01339 11.913 8.75 11.25 8.75C10.587 8.75 9.95107 9.01339 9.48223 9.48223C9.01339 9.95107 8.75 10.587 8.75 11.25Z",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.875H7.5",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.375H6.875",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_2201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertModal);
export default __webpack_public_path__ + "static/media/expertModal.066f87860027302846f3b8807e26e17b.svg";
export { ForwardRef as ReactComponent };